import { useLocation, useParams, Link } from 'react-router';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@repo/ui/Breadcrumb';
import { BREADCRUMB_LABELS, INTERMEDIATE_SEGMENTS } from '@/lib/breadcrumb-config';

export function AppBreadcrumbs() {
  const { pathname } = useLocation();
  const { accountId } = useParams<{ accountId: string }>();

  const segments = pathname.split('/').filter(Boolean);
  // Skip first 2 segments: "a" and accountId
  const routeSegments = segments.slice(2);

  // Filter out intermediate segments
  const filteredSegments = routeSegments.filter((seg) => !INTERMEDIATE_SEGMENTS.has(seg));

  if (filteredSegments.length === 0) {
    return (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>Home</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    );
  }

  // Build cumulative paths, skipping intermediate segments
  const crumbs = filteredSegments.map((segment) => {
    // Find this segment's position in the original routeSegments to build the correct path
    const originalIndex = routeSegments.indexOf(segment);
    const path = '/a/' + accountId + '/' + routeSegments.slice(0, originalIndex + 1).join('/');
    const label = BREADCRUMB_LABELS[segment] ?? segment;
    return { path, label };
  });

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={`/a/${accountId}`}>Home</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <span key={crumb.path} className="contents">
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.path}>{crumb.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </span>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
